<template>
  <div class="initiative-group-quick-create">
    <v-btn
      class="initiative-group-quick-create__btn"
      color="primary"
      icon
      @click="openDialog"
      :title="$t('Создать инициативную группу')"
      :aria-label="$t('Создать инициативную группу')"
    >
      <v-icon aria-hidden="true">mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="860" class="p-4">
      <v-card>
        <div class="modal-head d-flex justify-space-between align-center">
          <div class="modal-body font-weight-bold">{{ $t('Создание инициативной группы') }}</div>
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="dialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>

        <div class="modal-body">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.name"
                :label="$t('Наименование') + ' *'"
                :aria-label="$t('Наименование')"
                outlined
                rounded
                dense
                :error-messages="fieldErrors.name"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.nameKg"
                :label="$t('Наименование (кырг.)')"
                :aria-label="$t('Наименование (кырг.)')"
                outlined
                rounded
                dense
                :error-messages="fieldErrors.nameKg"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.regNumber"
                :label="$t('Регистрационный номер') + ' *'"
                :aria-label="$t('Регистрационный номер')"
                outlined
                rounded
                dense
                :error-messages="fieldErrors.regNumber"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-menu
                v-model="regDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.regDate"
                    :label="$t('Дата регистрации')"
                    :aria-label="$t('Дата регистрации')"
                    readonly
                    outlined
                    rounded
                    dense
                    v-on="on"
                    :error-messages="fieldErrors.regDate"
                  />
                </template>
                <v-date-picker
                  v-model="form.regDate"
                  @input="regDateMenu = false"
                  no-title
                  first-day-of-week="1"
                />
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model.trim="form.regAuthority"
                :label="$t('Наименование органа, выдавшего свидетельство о регистрации') + ' *'"
                :aria-label="$t('Наименование органа, выдавшего свидетельство о регистрации')"
                outlined
                rounded
                dense
                :error-messages="fieldErrors.regAuthority"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model.trim="form.leaders"
                :label="$t('Данные о руководителях') + ' *'"
                :aria-label="$t('Данные о руководителях')"
                outlined
                rounded
                dense
                rows="4"
                :error-messages="fieldErrors.leaders"
              />
            </v-col>
          </v-row>
        </div>

        <div class="modal-footer pa-4 d-flex justify-end">
          <v-btn class="mr-2" outlined @click="dialog = false">
            {{ $t('Отмена') }}
          </v-btn>
          <v-btn color="primary" :loading="loading" @click="create">
            {{ $t('Создать') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from '@/model/user'

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      regDateMenu: false,
      form: {
        name: '',
        nameKg: '',
        regNumber: '',
        regDate: '',
        regAuthority: '',
        leaders: ''
      },
      fieldErrors: {
        name: [],
        nameKg: [],
        regNumber: [],
        regDate: [],
        regAuthority: [],
        leaders: []
      }
    }
  },
  methods: {
    openDialog() {
      this.clearErrors()
      this.dialog = true
    },
    clearErrors() {
      this.fieldErrors = {
        name: [],
        nameKg: [],
        regNumber: [],
        regDate: [],
        regAuthority: [],
        leaders: []
      }
    },
    validate() {
      this.clearErrors()

      let isValid = true

      if (!this.form.name) {
        this.fieldErrors.name = [this.$t('Обязательное поле')]
        isValid = false
      }

      if (!this.form.regNumber) {
        this.fieldErrors.regNumber = [this.$t('Обязательное поле')]
        isValid = false
      }

      if (!this.form.regAuthority) {
        this.fieldErrors.regAuthority = [this.$t('Обязательное поле')]
        isValid = false
      }

      if (!this.form.leaders) {
        this.fieldErrors.leaders = [this.$t('Обязательное поле')]
        isValid = false
      }

      return isValid
    },
    create() {
      if (!this.validate()) {
        return
      }

      this.loading = true
      const fd = new FormData()
      fd.append('name', this.form.name)
      fd.append('nameKg', this.form.nameKg)
      fd.append('regNumber', this.form.regNumber)
      fd.append('regAuthority', this.form.regAuthority)
      fd.append('leaders', this.form.leaders)

      if (this.form.regDate) {
        fd.append('regDate', this.form.regDate)
      }

      User.createInitiativeGroup(fd).then((response) => {
        const initiativeGroup = response.data.initiativeGroup
        this.$emit('created', initiativeGroup)
        this.dialog = false
        this.form = {
          name: '',
          nameKg: '',
          regNumber: '',
          regDate: '',
          regAuthority: '',
          leaders: ''
        }
        this.loading = false
      }).catch((error) => {
        this.loading = false

        const formErrors = error?.response?.data?.initiativeGroupForm?.data?.errors?.form?.children

        if (formErrors) {
          Object.keys(this.fieldErrors).forEach((field) => {
            if (formErrors[field] && Array.isArray(formErrors[field].errors) && formErrors[field].errors.length) {
              this.fieldErrors[field] = formErrors[field].errors.map((err) => this.$t(err))
            }
          })
          return
        }

        this.$noty.error(error.message, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
      })
    }
  }
}
</script>

<style scoped>
.initiative-group-quick-create__btn {
  width: 34px;
  height: 34px;
  border: 1px solid currentColor;
  border-radius: 50%;
}

.modal-body {
  padding: 20px 24px;
}
</style>
